// Sunshine Coast suburbs Puppl serves, with the nearest puppy school hall.
export const HALLS = {
  mudjimba: { name: "Mudjimba Community Hall", address: "41 Cottonwood St, Mudjimba 4564", times: "Saturday Mornings & Monday Evenings" },
  kawana: { name: "Kawana Scouts Hall", address: "58 Illuka Avenue, Buddina 4575", times: "Monday Mornings" },
  eudlo: { name: "Eudlo Hall", address: "19 Rosebed Street, Eudlo 4554", times: "Wednesday Mornings" },
};

export const REGIONS = [
  {
    name: "North Sunshine Coast",
    hall: "mudjimba",
    suburbs: [
      "Mudjimba", "Twin Waters", "Pacific Paradise", "Maroochy", "Marcoola",
      "Bli Bli", "Diddillibah", "Maroochydore", "Coolum Beach", "Yaroomba",
    ],
  },
  {
    name: "Central Sunshine Coast",
    hall: "kawana",
    suburbs: [
      "Buddina", "Alexandra Headland", "Birtinya", "Bokarina", "Buderim",
      "Currimundi", "Forest Glen", "Kawana Island", "Kuluin", "Kunda Park",
      "Meridan Plains", "Minyama", "Mons", "Mooloolaba", "Mountain Creek",
      "Palmview", "Parrearra", "Sippy Downs", "Tanawha", "Warana", "Wurtulla",
    ],
  },
  {
    name: "West & Hinterland",
    hall: "eudlo",
    suburbs: [
      "Eudlo", "Palmwoods", "Chevallum", "Mooloolah Valley", "Diamond Valley",
      "Ilkley", "Landers Shoot", "Montville", "Woombye", "Kureelpa", "Hunchy",
      "West Woombye", "Balmoral Ridge", "Rosemount",
    ],
  },
];

export const slug = (s) => s.toLowerCase().replace(/&/g, "and").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export function findSuburb(suburbSlug) {
  for (const r of REGIONS) {
    const match = r.suburbs.find((s) => slug(s) === suburbSlug);
    if (match) return { suburb: match, region: r.name, hall: HALLS[r.hall], hallKey: r.hall };
  }
  return null;
}

export const ALL_SUBURBS = REGIONS.flatMap((r) => r.suburbs.map((s) => ({ suburb: s, region: r.name, hallKey: r.hall })));

// Sunshine Coast postcode → nearest hall key. Used by the homepage / services
// postcode-search input to route visitors straight to their local service-area page.
export const POSTCODE_TO_HALL = {
  // North
  "4564": "mudjimba",  // Mudjimba, Twin Waters, Pacific Paradise, Marcoola
  "4558": "mudjimba",  // Maroochydore + nearby
  "4561": "mudjimba",  // Bli Bli + Diddillibah
  "4573": "mudjimba",  // Coolum Beach, Yaroomba
  // Central / Kawana
  "4575": "kawana",    // Buddina, Bokarina, Birtinya, Warana, Kawana Island, Parrearra, Currimundi, Wurtulla, Minyama, Mountain Creek
  "4556": "kawana",    // Buderim, Forest Glen, Kunda Park, Sippy Downs, Mons, Tanawha, Palmview
  "4557": "kawana",    // Mooloolaba, Alexandra Headland
  "4551": "kawana",    // Meridan Plains, Caloundra West, Little Mountain
  // West & Hinterland / Eudlo
  "4554": "eudlo",     // Eudlo, Palmwoods, Chevallum, Woombye, Hunchy, Kureelpa
  "4553": "eudlo",     // Mooloolah Valley, Diamond Valley
  "4552": "eudlo",     // Maleny, Montville (extended hinterland)
  "4555": "eudlo",     // Landsborough + adjacent hinterland
};

export function findHallByPostcode(postcode) {
  if (!postcode) return null;
  const key = POSTCODE_TO_HALL[String(postcode).trim()];
  if (!key) return null;
  const region = REGIONS.find((r) => r.hall === key);
  if (!region) return null;
  return {
    hall: HALLS[key],
    hallKey: key,
    region: region.name,
    primarySuburbSlug: slug(region.suburbs[0]),
  };
}

